const o="1.12.0";export{o as version};
